"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _Button = _interopRequireDefault(require("../Button"));
var _Text = _interopRequireDefault(require("../Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Tab = function Tab(props) {
  var children = props.children,
    active = props.active,
    onClick = props.onClick;
  var rootClass = (0, _useCss["default"])(function () {
    return {
      flexShrink: 0
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
    onClick: onClick,
    padding: [1.25, 1.5],
    className: rootClass,
    variant: active ? 'filled' : 'text',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text["default"], {
      weight: "bold",
      children: children
    })
  });
};
var _default = Tab;
exports["default"] = _default;